module.exports = __webpack_public_path__ + "static/media/loadsDeliveredGradient.d471c4ac.svg";